import { addDays, endOfWeek, format, startOfWeek } from "date-fns";

export interface CellState {
  available: boolean;
  override: boolean;
  originalAvailable: boolean;
  dirty: boolean;
}

export const shifts: Array<"AM" | "PM" | "OT"> = ["AM", "PM", "OT"];

export const shiftHours: Record<"AM" | "PM" | "OT", string> = {
  AM: "6:00 - 14:00",
  PM: "14:00 - 22:00",
  OT: "22:00 - 6:00"
};

export function buildWeek(date: Date): Date[] {
  const start = startOfWeek(date, { weekStartsOn: 1 }); // Monday
  return Array.from({ length: 7 }).map((_, i) => addDays(start, i));
}

/** Build calendar days covering full Mon–Sun weeks that span the given month. */
export function buildMonth(date: Date): Date[] {
  const firstDayOfMonth = new Date(date.getFullYear(), date.getMonth(), 1);
  const lastDayOfMonth = new Date(date.getFullYear(), date.getMonth() + 1, 0);
  const calendarStart = startOfWeek(firstDayOfMonth, { weekStartsOn: 1 });
  const calendarEnd = endOfWeek(lastDayOfMonth, { weekStartsOn: 1 });
  const days: Date[] = [];
  let cursor = calendarStart;
  while (cursor <= calendarEnd) {
    days.push(cursor);
    cursor = addDays(cursor, 1);
  }
  return days; // 35 or 42 days depending on month span
}

export function getPeriodDescription(
  activeView: "weekly" | "monthly",
  baseDate: Date,
  daysOfWeek: Date[]
): string {
  if (activeView === "monthly") {
    return format(baseDate, "MMMM yyyy");
  }
  const start = daysOfWeek[0];
  const end = daysOfWeek[6];
  const startMonth = format(start, "MMM");
  const endMonth = format(end, "MMM");
  if (startMonth === endMonth) {
    return `${startMonth} ${format(start, "d")}-${format(end, "d yyyy")}`;
  }
  return `${startMonth} ${format(start, "d")}-${format(end, "d MMM yyyy")}`;
}

/** Normalise a backend shiftType (numeric or string) to "AM" | "PM" | "OT". */
export function normaliseShift(
  raw: string | number | undefined | null
): "AM" | "PM" | "OT" | undefined {
  if (!raw) return undefined;
  if (raw === "AM" || raw === "PM" || raw === "OT") return raw;
  if (raw === 1) return "AM";
  if (raw === 2) return "PM";
  if (raw === 3) return "OT";
  return undefined;
}
